import { __awaiter, __generator } from "tslib";
export function loadDemandbase(analytics) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var Demandbase, company;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Demandbase = window.Demandbase;
                    if (!Demandbase) {
                        return [2 /*return*/];
                    }
                    if (!Demandbase ||
                        !Demandbase.Segments ||
                        !Demandbase.Segments.IsCompany ||
                        !Demandbase.Segments.CompanyProfile ||
                        ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website)) {
                        return [2 /*return*/];
                    }
                    company = Demandbase.Segments.CompanyProfile;
                    if (!company.isp && !company.web_site) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, analytics.group(company.demandbase_sid, {
                            website: company.web_site,
                            intentSource: 'demandbase',
                            name: company.company_name || undefined,
                            country: company.country_name || undefined,
                            industry: company.industry || undefined,
                            number_of_employees: company.employee_count || undefined,
                            annual_revenue: company.annual_sales || undefined,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=demandbase.js.map